import { createContext } from 'react';

export type CaptureStatus =
  | 'idle'
  | 'sdk_loading'
  | 'awaiting_permission'
  | 'camera_active'
  | 'processing'
  | 'success'
  | 'error';

export type UnicoCaptureResult = {
  process_id: string;
  provider: 'unico';
  capture_type: 'selfie_liveness';
  encrypted: string;
  raw_base64: string;
  token: {
    issued_at: string;
    expires_at: string;
    ttl_seconds: number;
    is_expired: boolean;
  };
  proxy: {
    status: 'pending' | 'sent' | 'failed' | 'skipped_expired';
    dispatched_at: string | null;
    payload: {
      process_id: string;
      provider: 'unico';
      capture_type: 'selfie_liveness';
      encrypted: string;
      metadata: {
        captured_at: string;
        environment: 'UAT' | 'PROD';
        source: 'web';
        user_agent: string;
        process_persistence: 'session_storage';
      };
      token: {
        issued_at: string;
        expires_at: string;
        ttl_seconds: number;
        is_expired: boolean;
      };
      integrations: {
        serpro: {
          score_result: null;
          face_match_result: null;
          base_consulted: null;
          similarity_value: null;
        };
        salesforce: {
          score_result: null;
          face_match_result: null;
          base_consulted: null;
          similarity_value: null;
        };
      };
    };
  };
  metadata: {
    captured_at: string;
    environment: 'UAT' | 'PROD';
    source: 'web';
    user_agent: string;
    process_persistence: 'session_storage';
  };
};

export type UnicoContextValue = {
  status: CaptureStatus;
  error: string | null;
  result: UnicoCaptureResult | null;
  initializeSession: () => void;
  cleanupSession: () => void;
  openLivenessCapture: () => Promise<void>;
  resetCapture: () => void;
};

export const UnicoContext = createContext<UnicoContextValue | null>(null);
